import parserUtils from '../data/utils'
import { toNumber, get } from 'lodash'
import { CustomSegment } from '@node/wam-audience-builder'

const helpers = {
    parseData: data => {
        const _data = []
        for (const val of data) {
            const wamData = {
                id: toNumber(val.id),
                category: 'customTaxonomy',
                label: val.label,
                isSelectable: false,
                lazyLoading: true,
                parentJsonKeyName: null,
                jsonKey: {
                    name: 'custom_taxonomy_' + val.id,
                    type: 'customTaxonomy',
                    subType: 'customTaxonomies',
                    ids: [toNumber(val.id)]
                }
            }
            _data.push(wamData)
        }
        return _data.sort((a, b) => (a.display_order > b.display_order ? 1 : b.display_order > a.display_order ? -1 : 0))
    },

    parseDataHierarchies: (subType, data, taxonomyId, recency) => {
        const _data = []
        for (const val of data) {
            const wamData = {
                taxonomyId: toNumber(taxonomyId),
                id: toNumber(val.id),
                category: get(val, 'custom_category', null),
                label: val.label,
                isSelectable: true,
                display_order: toNumber(val.display_order),
                hasChild: parserUtils.findChild(data, val.id),
                parentJsonKeyName: parserUtils.getParentJsonKeyName(get(val, 'parent_wam_custom_segment_id', null), val),
                identifier: toNumber(get(val, 'custom_identifier', null)),
                smartSegments: val.smart_segments,
                smartSegmentIds: parserUtils.getSmartSegmentIds(get(val, 'smart_segments', null)),
                customTaxoRecency: recency,
                jsonKey: {
                    name: 'custom_segment_' + val.id,
                    type: 'CustomSegment',
                    subType: subType,
                    ids: [toNumber(val.id)]
                }
            }
            _data.push(wamData)
        }
        const sortedData = _data.sort((a, b) => (a.display_order > b.display_order ? 1 : b.display_order > a.display_order ? -1 : 0))
        return sortedData
    },

    instanciateAll: (taxonomies, segments, opts = {}, previousData = []) => {
        const taxos = taxonomies.map(taxonomy => ({
            id: parseInt(taxonomy.id),
            label: taxonomy.label,
            displayOrder: parseInt(taxonomy.display_order),
            path: ['MyData', 'Taxonomies'],
            selectable: false,
            category: 'CustomTaxonomy',
        }))
        const segs = segments.map(segment => {

            let parentCategory = 'CustomTaxonomy'
            let parentId = parseInt(segment.wam_custom_taxonomy_id)

            if (segment.parent_wam_custom_segment_id) {
                parentCategory = 'CustomSegment'
                parentId = parseInt(segment.parent_wam_custom_segment_id)
            }

            return {
                id: parseInt(segment.id),
                label: segment.label,
                parentId: CustomSegment.generateCrossId({
                    category: parentCategory,
                    id: parentId
                }),
                displayOrder: parseInt(segment.display_order),
                smartSegments: (segment.smart_segments || []).map(i => ({
                    createdAt: new Date(i.created_at),
                    id: i.id,
                    periodFrom: parseInt(i.period_from),
                    periodTo: parseInt(i.period_to),
                })),
                path: ['MyData', 'Taxonomies'],
                category: 'CustomSegment',
                retention: taxonomies.find(taxo => taxo.id == segment.wam_custom_taxonomy_id)?.retention,
                displayId: true,
                frequencyOpts: opts.frequencyOpts
            }
        })
        const allCusSegs = CustomSegment.createAll([
            ...taxos,
            ...segs,
        ], previousData)

        return allCusSegs
    }
}

export default helpers
